import locationService from '@/services/location.service';
import { map } from 'lodash';
var state = {
    location: {
        id: null
    },
    minimumDelivery: 0,
    locations: [],
};
var getters = {
    getLocation: function (state) { return state.location; },
    getMinimumDelivery: function (state) { return state.minimumDelivery; },
    getLocationCoordinates: function (state) {
        var locations = state.locations;
        var coordinates = map(locations, function (location) {
            var latitude = location.latitude, longitude = location.longitude, base = location.base;
            return {
                latitude: latitude,
                longitude: longitude,
                base: base,
            };
        });
        return coordinates;
    },
    getLoadedLocations: function (state) { return state.locations; },
};
var actions = {
    setLocation: function (_a, location) {
        var commit = _a.commit;
        commit('setLocation', location);
        if (location.delivery) {
            var minimumDelivery = location.delivery.minimumDelivery;
            commit('setMinimumDelivery', minimumDelivery);
        }
    },
    setLocations: function (_a, locations) {
        var commit = _a.commit;
        commit('setLocations', locations);
    },
    setMinimumDelivery: function (_a, minimumDelivery) {
        var commit = _a.commit;
        commit('setMinimumDelivery', minimumDelivery);
    }
};
var mutations = {
    setLocation: function (state, location) {
        state.location = location;
        locationService.setLocationForStorage(location);
    },
    setLocations: function (state, locations) {
        state.locations = locations;
    },
    setMinimumDelivery: function (state, minimumDelivery) {
        state.minimumDelivery = minimumDelivery;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/location.store.ts
// module id = null
// module chunks = 